import React, { useEffect, useState, useRef } from 'react'
import './fadeImage.css'
const wordpress = true
const imagepath = wordpress ? '/wp-content/reactpress/apps/idesign/' : '/'
const sections = [
  {
    id: '1',
    title: 'Geoddle',
    text: 'Geoddle | Versatile yet simple tool to create drawings, digital cards, greetings and engineering drawings.',
    image: `${imagepath}assets/images/product/geoddle.png`,
    features: [
      'Convert photographs into personal greetings',
      'Create complex drawings with easy-to-use features',
      'Create digital cards for any occasion',
    ],
  },
  {
    id: '2',
    title: 'NeoPlanner',
    text: '"ADVANCED PERSONAL PLANNER & TEAM ORGANIZER" – the ultimate app designed to revolutionize the way you plan, collaborate, and achieve your goals.',
    image: `${imagepath}assets/images/product/neoplanner.jpg`,
    features: [
      'Personalized planning experience',
      'Seamless collaboration with your team',
      'Intuitive interface for effortless navigation',
    ],
  },
  {
    id: '3',
    title: 'Nuehee',
    text: 'Empowering Your Health Journey with Personalized Care. Access To & Finding the Right Dietitian is Hard. Not Anymore!',
    image: `${imagepath}assets/images/product/nuehee.png`,
    features: [
      'Empowering Your Health Journey with Personalized Care!',
      'Faster care delivery',
      'Elevate Your Health with NueHee',
    ],
  },
  {
    id: '4',
    title: 'Contact tracing',
    text: 'Real-time tracking and visibility, connecting physical assets with digital systems for smarter decision-making and streamlined operations.',
    image: `${imagepath}assets/images/product/contacttracing.jpg`,
    features: [
      'Real-time tracking and visibility',
      'Connecting physical assets with digital systems',
      'Smarter decision-making and streamlined operations',
    ],
  },
  {
    id: '5',
    title: 'Uninotes',
    text: 'Organizing your world now gets smarter with UniNotes. UniNotes is a personal organizer that can organize your data including Contacts, Notes and Messages.',
    image: `${imagepath}assets/images/product/uninotes.jpg`,
    features: [
      'Organizing your world now gets smarter',
      'Personal organizer for your data',
      'Includes Contacts, Notes, and Messages',
    ],
  },
  {
    id: '6',
    title: 'Industry 4.0',
    text: 'Tracking and tracing every asset and worker in real time allows you to optimise your warehouse routes and operability, while enhancing worker safety.',
    image: `${imagepath}assets/images/product/industry40.jpg`,
    features: [
      'Real-time tracking and tracing',
      'Optimise warehouse routes and operability',
      'Enhance worker safety',
    ],
  },
]

export default function ServiceScrollSection() {
  const [activeImage, setActiveImage] = useState(sections[0].image)
  const sectionRefs = useRef([])
  const scrollContainerRef = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    if (!scrollContainer) return

    const handleScroll = () => {
      const containerRect = scrollContainer.getBoundingClientRect()
      let newIndex = currentIndex

      for (let i = 0; i < sectionRefs.current.length; i++) {
        const ref = sectionRefs.current[i]
        if (!ref) continue

        const rect = ref.getBoundingClientRect()
        const offsetTop = rect.top - containerRect.top

        // Trigger when top of the section hits top of scroll container
        if (offsetTop >= 0 && offsetTop < containerRect.height / 2) {
          newIndex = i
          break
        }
      }

      if (newIndex !== currentIndex) {
        setCurrentIndex(newIndex)
        setActiveImage(sections[newIndex].image)
      }

      sectionRefs.current.forEach((ref, index) => {
        if (!ref) return
        if (index === newIndex) {
          ref.classList.add('fade-text')
        } else {
          ref.classList.remove('fade-text')
        }
      })
    }

    scrollContainer.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => scrollContainer.removeEventListener('scroll', handleScroll)
  }, [currentIndex])

  const scrollToSection = (index) => {
    if (index < 0 || index >= sections.length) return

    const scrollContainer = scrollContainerRef.current
    const targetSection = sectionRefs.current[index]

    if (scrollContainer && targetSection) {
      // FIX: Calculate scroll offset relative to container, not the whole page
      const containerTop = scrollContainer.getBoundingClientRect().top
      const sectionTop = targetSection.getBoundingClientRect().top
      const scrollOffset = sectionTop - containerTop + scrollContainer.scrollTop

      scrollContainer.scrollTo({ top: scrollOffset, behavior: 'smooth' })

      // Update image and index immediately
      setCurrentIndex(index)
      setActiveImage(sections[index].image)

      sectionRefs.current.forEach((el, idx) => {
        if (!el) return
        el.classList.toggle('fade-text', idx === index)
      })
    }
  }

  return (
    <div className='container mt-3 gap-1'>
      {/* Arrow buttons */}
      <div className='row  p-0 mb-2'>
        <div className='col d-flex justify-content-start p-0'>
          <button
            type='button'
            className='btn  '
            onClick={() => scrollToSection(currentIndex - 1)}
            disabled={currentIndex === 0}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='Previous'
          >
            <i className='bi bi-arrow-left'></i>
          </button>
        </div>
        <div className='col d-flex justify-content-end p-0'>
          <button
            type='button'
            className='btn  '
            onClick={() => scrollToSection(currentIndex + 1)}
            disabled={currentIndex === sections.length - 1}
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title='Next'
          >
            <i className='bi bi-arrow-right'></i>
          </button>
        </div>
      </div>

      <div className='row productsborder flex-column flex-md-row'>
        <div className='col-12 col-md-6 productsborder d-flex align-items-center justify-content-center bg-light p-3'>
          <img
            src={activeImage}
            alt='Current'
            className='img-fluid'
            style={{
              maxHeight: '360px',
              objectFit: 'contain',
              maxWidth: '100%',
            }}
          />
        </div>

        {/* Scrollable Description Column */}
        <div
          className='col-12 col-md-6 p-4 custom-scrollbar'
          style={{
            maxHeight: '380px',
            overflowY: 'auto',
            scrollBehavior: 'smooth',
          }}
          ref={scrollContainerRef}
        >
          {sections.map((section, index) => (
            <div
              key={section.id}
              ref={(el) => (sectionRefs.current[index] = el)}
              className='d-flex flex-column justify-content-center align-items-start mb-5 opacity-0'
              style={{
                minHeight: '370px',
                transition: 'opacity 0.8s ease-in-out',
              }}
            >
              <h4 className='fs-5 mb-3 font-semibold font-semibold'>
                {section.title}
              </h4>
              <p className='description text-muted-foreground'>
                {section.text}
              </p>
              <ul>
                {section.features.map((feature, idx) => (
                  <li key={idx} className='text-muted-foreground'>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
